import React, { Component } from "react"
import { Link } from "react-router-dom"
import _ from "lodash"
import $ from "jquery"
import SidebarHeader from "./SidebarHeader"
import { EmeraldHost, AssetHost, FeedbackLink } from "../config"
import "../assets/js/pages.js"
import "../assets/css/components/sidebar.css"

import { library } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faGlobe,
  faGamepad,
  faExternalLinkAlt,
  faBook,
  faLightbulb,
  faFileLines,
  faGear,
  faHouseChimney,
  faCloudSunRain,
  faLeaf,
  faDna,
  faUsers,
  faGears,
  faHand,
  faList,
  faRocket,
  faVolcano,
  faChartSimple
} from "@fortawesome/free-solid-svg-icons"
import {
  getCurrentRole,
  EDUCATOR,
  PARENT,
  HOMESCHOOLER,
  STUDENT,
  CHILD,
  isDevEnvironment
} from "../util"
library.add(
  faGlobe,
  faGamepad,
  faExternalLinkAlt,
  faBook,
  faLightbulb,
  faFileLines,
  faGear,
  faHouseChimney,
  faCloudSunRain,
  faLeaf,
  faDna,
  faUsers,
  faGears,
  faHand,
  faList,
  faRocket,
  faVolcano,
  faChartSimple
)

const thumbnailIconSize = {
  width: "15px",
  height: "15px"
}

const sidebarLinks = {
  emeraldWelcome: EmeraldHost() + "welcome",
  welcome: "/home",
  emeraldAccount: EmeraldHost() + "accounts",
  emeraldPayments: EmeraldHost() + "payments",
  emeraldLogout: EmeraldHost() + "logout",
  classRegistration: "/register_for_class",
  family: "/family",
  classRosters: "/classes",
  trackProgress: "/track_progress",
  calendar: "/calendar",
  expeditions: "/expeditions",
  playTheGame: AssetHost(),
  community: "https://community.tytoonline.com",
  support: {
    knowledgebase: "http://support.immersedgames.com/",
    trainingVideos: "https://www.tytoonline.com/training/",
    tutorialVideos: "https://www.youtube.com/playlist?list=PL84Pvj8x5B02gzVx9O-KzGcjnqCDUU0AZ",
    giveFeedback: FeedbackLink()
  },
  modules: {
    main: "/modules",
    general: "/modules/3",
    cells: "/modules/5",
    ecology: "/modules/1",
    geneticsNaturalSelection: "/modules/2",
    weatherAndClimate: "/modules/6",
    grade6Math2: "/modules/10",
    earthScience: "/modules/11",
    search: "/modules/search"
  }
}
export { sidebarLinks }

export default class Sidebar extends Component {
  componentDidMount() {
    this.conditionallyInitSidebar()
  }
  componentDidUpdate() {
    this.conditionallyInitSidebar()
  }

  conditionallyInitSidebar = () => {
    // Don't intialize the sidebar until data is finished loading
    if (!_.isEmpty(this.props.currentUser)) {
      $.Pages.initSidebar()
    }
  }

  userRole = getCurrentRole(this.props.currentUser)

  getVideosLink = isEducator => {
    return isEducator ? (
      <a target='_blank' href={sidebarLinks.support.trainingVideos}>
        Training
      </a>
    ) : (
      <a target='_blank' href={sidebarLinks.support.tutorialVideos}>
        Tutorial Videos
      </a>
    )
  }

  getTeacherSidebar = () => {
    return [
      <li key='1' data-testid='explore-assign'>
        <span className='expander'>
          <span className='title'>Explore & Assign</span>
          <span className=' arrow'></span>
        </span>
        <span className='icon-thumbnail'>
          <FontAwesomeIcon icon='globe' style={thumbnailIconSize} />
        </span>
        <ul className='sub-menu'>
          <li>
            <Link to='/modules'>List Modules</Link>
            <span className='icon-thumbnail'>
              <FontAwesomeIcon icon={faList} style={thumbnailIconSize} />
            </span>
          </li>
          <li>
            <Link to={sidebarLinks.modules.general}>General</Link>
            <span className='icon-thumbnail'>
              <FontAwesomeIcon icon={faHand} style={thumbnailIconSize} />
            </span>
          </li>
          <li>
            <Link to={sidebarLinks.modules.cells}>Cells to Organisms</Link>
            <span className='icon-thumbnail'>
              <FontAwesomeIcon icon={faGears} style={thumbnailIconSize} />
            </span>
          </li>
          <li>
            <Link to={sidebarLinks.modules.geneticsNaturalSelection}>
              Growth, Genetics & Natural Selection
            </Link>
            <span className='icon-thumbnail'>
              <FontAwesomeIcon icon={faDna} style={thumbnailIconSize} />
            </span>
          </li>
          <li>
            <Link to={sidebarLinks.modules.ecology}>Ecology</Link>
            <span className='icon-thumbnail'>
              <FontAwesomeIcon icon={faLeaf} style={thumbnailIconSize} />
            </span>
          </li>
          <li>
            <Link to={sidebarLinks.modules.weatherAndClimate}>Weather & Climate</Link>
            <span className='icon-thumbnail'>
              <FontAwesomeIcon icon={faCloudSunRain} style={thumbnailIconSize} />
            </span>
          </li>
          <li>
            <Link to={sidebarLinks.modules.grade6Math2}>6th Grade Math 2</Link>
            <span className='icon-thumbnail'>
              <FontAwesomeIcon icon={faChartSimple} style={thumbnailIconSize} />
            </span>
          </li>
          <li>
            <Link to={sidebarLinks.modules.earthScience}>Earth's Systems</Link>
            <span className='icon-thumbnail'>
              <FontAwesomeIcon icon={faVolcano} style={thumbnailIconSize} />
            </span>
          </li>
        </ul>
      </li>,
      <li key='2' data-testid='calendar'>
        <Link to={sidebarLinks.calendar}>
          <span className='title'>Calendar</span>
        </Link>
        <span className='icon-thumbnail'>
          <i className='pg-calender'></i>
        </span>
      </li>,
      <li key='3' data-testid='track-progress'>
        <Link to={sidebarLinks.trackProgress}>
          <span className='title'>Track Progress</span>
        </Link>
        <span className='icon-thumbnail'>
          <FontAwesomeIcon icon='tachometer-alt' style={thumbnailIconSize} />
        </span>
      </li>,
      ...(isDevEnvironment() || process.env.REACT_APP_FEATURE_TOGGLE === "ON"
        ? [
            <li key='4' data-testid='expeditions'>
              <Link to={sidebarLinks.expeditions}>
                <span className='title'>Expeditions</span>
              </Link>
              <span className='icon-thumbnail'>
                <FontAwesomeIcon icon={faRocket} style={thumbnailIconSize} />
              </span>
            </li>
          ]
        : [])
    ]
  }

  render() {
    return (
      <nav className='page-sidebar' data-pages='sidebar' data-testid='page-sidebar'>
        <SidebarHeader />

        {this.userRole === null && (
          <div className='loading-container' data-testid='loading-container'>
            <h1 className='loading'>Loading...</h1>
          </div>
        )}
        {this.userRole !== null && (
          <div className='sidebar-menu'>
            <ul className='menu-items' data-testid='sidebar-menu'>
              {/* All - Welcome */}
              <li data-testid='welcome'>
                {this.userRole === EDUCATOR ||
                this.userRole === STUDENT ||
                this.userRole === CHILD ? (
                  <Link to={sidebarLinks.welcome}>
                    <span className='title'>Welcome</span>
                  </Link>
                ) : (
                  <a href={sidebarLinks.emeraldWelcome}>
                    <span className='title'>Welcome</span>
                  </a>
                )}
                <span className='icon-thumbnail'>
                  <FontAwesomeIcon icon={faHouseChimney} style={thumbnailIconSize} />
                </span>
              </li>

              {/* Educator and Homeschooler options - Explore and Assign, Calendar, Track progress*/}
              {(this.userRole === EDUCATOR || this.userRole === HOMESCHOOLER) &&
                this.getTeacherSidebar()}

              {/* Educator - Manage Classes */}
              {this.userRole === EDUCATOR && (
                <li key='4' data-testid='manage-classes'>
                  <Link to={sidebarLinks.classRosters}>
                    <span className='title'>Manage Classes</span>
                  </Link>
                  <span className='icon-thumbnail'>
                    <FontAwesomeIcon icon='th-large' style={thumbnailIconSize} />
                  </span>
                </li>
              )}

              {/* Parent - Track Progress Family (temporarily hidden since the family track progress page itself is broken ) */}
              {/* {(this.getCurrentUser()['is-parent'] && !this.getCurrentUser()['is-homeschooler']) &&
                (<li key='default1'>
                  <Link to={sidebarLinks.family}>
                    <span className="title">Track Progress</span>
                  </Link>
                  <span className="icon-thumbnail"><FontAwesomeIcon icon="tachometer-alt"/></span>
                </li>)
              } */}

              {/* All - Account */}
              <li key='account1' data-testid='account'>
                <a href={sidebarLinks.emeraldAccount}>
                  <span className='title'>Account</span>
                </a>
                <span className='icon-thumbnail'>
                  <FontAwesomeIcon icon='user' style={thumbnailIconSize} />
                </span>
              </li>

              {/* Parent & Homeschooler - Payments */}
              {(this.userRole === PARENT || this.userRole === HOMESCHOOLER) && (
                <li key='account2' data-testid='payment'>
                  <a href={sidebarLinks.emeraldPayments}>
                    <span className='title'>Payments</span>
                  </a>
                  <span className='icon-thumbnail'>
                    <FontAwesomeIcon icon='wallet' style={thumbnailIconSize} />
                  </span>
                </li>
              )}

              {/* Educator - Community */}
              {this.userRole === EDUCATOR && (
                <li key='account2' data-testid='community'>
                  <a href={sidebarLinks.community} target='_blank'>
                    <span className='title'>Community</span>
                  </a>
                  <span className='icon-thumbnail'>
                    <FontAwesomeIcon icon='users' style={thumbnailIconSize} />
                  </span>
                </li>
              )}

              {/*Student - Class Registration*/}
              {this.userRole === STUDENT && (
                <li key='default2' data-testid='class-registration'>
                  <Link to={sidebarLinks.classRegistration}>
                    <span className='title'>Class Registration</span>
                  </Link>
                  <span className='icon-thumbnail'>
                    <FontAwesomeIcon icon='user-plus' style={thumbnailIconSize} />
                  </span>
                </li>
              )}

              {/* Educator, Parent, Homeschooler - Support */}
              {(this.userRole === EDUCATOR ||
                this.userRole === HOMESCHOOLER ||
                this.userRole === PARENT) && (
                <li key='account3' data-testid='support'>
                  <span className='expander'>
                    <span className='title'>Support</span>
                    <span className=' arrow'></span>
                  </span>
                  <span className='icon-thumbnail'>
                    <FontAwesomeIcon icon={faGear} style={thumbnailIconSize} />
                  </span>
                  <ul className='sub-menu'>
                    <li className=''>
                      <a target='_blank' href={sidebarLinks.support.knowledgebase}>
                        Knowledge Base
                      </a>
                      <span className='icon-thumbnail'>
                        <FontAwesomeIcon icon={faBook} style={thumbnailIconSize} />
                      </span>
                    </li>
                    <li className=''>
                      {this.getVideosLink(this.userRole === EDUCATOR)}
                      <span className='icon-thumbnail'>
                        <FontAwesomeIcon icon={faFileLines} style={thumbnailIconSize} />
                      </span>
                    </li>
                    {this.userRole === EDUCATOR && (
                      <li>
                        <a target='_blank' href={sidebarLinks.support.giveFeedback}>
                          Give Feedback
                        </a>
                        <span className='icon-thumbnail'>
                          <FontAwesomeIcon icon={faLightbulb} style={thumbnailIconSize} />
                        </span>
                      </li>
                    )}
                  </ul>
                </li>
              )}

              {/* Educator, Homeschooler, Parent - Play the Game */}
              {(this.userRole === EDUCATOR ||
                this.userRole === HOMESCHOOLER ||
                this.userRole === PARENT) && (
                <li key='account6' data-testid='educator-playGame'>
                  <a target='_blank' href={sidebarLinks.playTheGame}>
                    <span className='title'>
                      Play the Game{" "}
                      <FontAwesomeIcon icon='external-link-alt' style={thumbnailIconSize} />
                    </span>
                  </a>
                  <span className='icon-thumbnail'>
                    <FontAwesomeIcon icon='gamepad' style={thumbnailIconSize} />
                  </span>
                </li>
              )}

              {/* All - Log out */}
              <li key='account5' data-testid='logout'>
                <a href={EmeraldHost() + "logout"}>
                  <span className='title'>Logout</span>
                </a>
                <span className='icon-thumbnail'>
                  <FontAwesomeIcon icon='sign-out-alt' style={thumbnailIconSize} />
                </span>
              </li>
            </ul>

            <div className='clearfix'></div>
          </div>
        )}
      </nav>
    )
  }
}
